var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        "list-group__sticky":
          _vm.stickyCategoryId === `category_${_vm.listGroup.id}` &&
          !_vm.isOpen,
      },
      attrs: { id: `category_${_vm.listGroup.id}` },
    },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c("div", { staticClass: "list-group" }, [
        _c(
          "div",
          { staticClass: "list-group__left-side" },
          [
            _c("toggle-button", {
              staticClass: "documents-group__toggler",
              attrs: {
                disabled: !_vm.canGroupBeOpened,
                "disabled-popover": "Пустая категория",
              },
              model: {
                value: _vm.isOpen,
                callback: function ($$v) {
                  _vm.isOpen = $$v
                },
                expression: "isOpen",
              },
            }),
            _c("div", { staticClass: "list-group__label" }, [
              _vm._v(" " + _vm._s(_vm.listGroup.name) + " "),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "list-group__actions" },
          [
            _c("c-button", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover blur",
                    boundary: "window",
                    content: "Редактировать",
                    placement: "top",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover blur',\n          boundary: 'window',\n          content: 'Редактировать',\n          placement: 'top',\n        }",
                  modifiers: { html: true },
                },
              ],
              attrs: { size: "iconic", icon: "edit" },
              on: { click: _vm.onGroupEdit },
            }),
            _c(
              "div",
              {
                staticClass: "list-group__actions-remove",
                attrs: { id: `list-group-${_vm.listGroup.id}` },
              },
              [
                _c("c-button", {
                  directives: [
                    {
                      name: "b-popover",
                      rawName: "v-b-popover.html",
                      value: {
                        container: "#app",
                        trigger: "hover blur",
                        boundary: "window",
                        content: "Удалить",
                        placement: "top",
                      },
                      expression:
                        "{\n            container: '#app',\n            trigger: 'hover blur',\n            boundary: 'window',\n            content: 'Удалить',\n            placement: 'top',\n          }",
                      modifiers: { html: true },
                    },
                  ],
                  staticClass: "list-group__actions-remove",
                  attrs: {
                    size: "iconic",
                    icon: { icon: "trash", color: "secondary" },
                    disabled: _vm.cannotBeDeleted,
                  },
                  on: { click: _vm.deleteListGroup },
                }),
              ],
              1
            ),
            _c("c-button", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover blur",
                    boundary: "window",
                    content: "Переместить",
                    placement: "top",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover blur',\n          boundary: 'window',\n          content: 'Переместить',\n          placement: 'top',\n        }",
                  modifiers: { html: true },
                },
              ],
              attrs: { size: "iconic", icon: "arrows-constructor" },
            }),
            _vm.cannotBeDeleted
              ? _c(
                  "b-popover",
                  {
                    attrs: {
                      triggers: "hover blur",
                      target: `list-group-${_vm.listGroup.id}`,
                    },
                  },
                  [
                    _c("error-feedback", {
                      attrs: {
                        text: "В данный момент удаление невозможно, так как категория содержит данные. Сначала перенесите все данные из\n          категории",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "slide-up-down",
        {
          staticClass: "list-group__draggable",
          attrs: { active: _vm.isOpen, duration: 400 },
          on: { "open-start": _vm.onGroupOpen },
        },
        [
          !_vm.isLoading
            ? _c(
                "draggable",
                {
                  attrs: {
                    group: "type",
                    "force-fallback": true,
                    "ghost-class": "sortable__ghost",
                  },
                  on: { change: _vm.changeHandler, update: _vm.updateHandler },
                  model: {
                    value: _vm.listGroupItemsSorted,
                    callback: function ($$v) {
                      _vm.listGroupItemsSorted = $$v
                    },
                    expression: "listGroupItemsSorted",
                  },
                },
                _vm._l(_vm.listGroupItemsSorted, function (item) {
                  return _c("list-group-item", {
                    key: item.id,
                    attrs: {
                      "list-group-item": item,
                      "selected-list-group-items-status":
                        _vm.selectedListGroupItemsStatus,
                    },
                    on: {
                      "edit-list-group-item": _vm.onListGroupItemEdit,
                      "on-delete-list-group-item": function ($event) {
                        return _vm.$emit("on-delete-list-group-item")
                      },
                    },
                  })
                }),
                1
              )
            : _c("c-loader", { attrs: { active: true, height: "80" } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }